import {
  applySnapshot,
  Instance,
  SnapshotIn,
  SnapshotOut,
  flow,
  types,
  getRoot,
} from 'mobx-state-tree';

// import gift from '../gift'
import createStore from '../../../lib/create-store';

const GiftModel = types
  .model('GiftModel', {
    id: types.identifierNumber,
    name: '',
    status: false,
    pic_url: 'https://img.sumeme.com/59/3/1452150023355.jpg', // 默认空白图片
    pic_pre_url: '',
    desc: '',
    count: 0,
    coin_price: 0,
    exp: 0,
    order: 0,
    swf_pc_url: '',
    sale: false,
    level_limit: 0,
    corner_enabled: false,
    corner_pos: 0,
    corner_text: '',
    corner_color: '',
    corner_bg_img: '',
    animate_pos: 0, // 0 全屏，1 上半区，2 下半区，3 左侧小区域
    isBag: false,
    days: 0, // 背包中礼物 有效天数
    room_id: 0, // 指定房间    房间内的用户都可以看到专属礼物
    user_id: 0, // 指定用户
    oneself: false, // 是否可以送给自己
    extra_intimate_value: 0, // 额外亲密值
    privilege_type: 0, //  0：否 1：贵族礼物 2：守护礼物 3：真爱团礼物
    need_love_group_level: 0, // 解锁真爱团等级
    pay_level: 0, // 会员充值等级限制
    pay_level_name: '', // 会员充值等级限制名称
  })
  .views((self) => {
    return {
      get accunulate() {
        let { multiLuckyGifts = [] } = getRoot(self);
        let gift = multiLuckyGifts.find((i) => {
          return i.gift_id === self.id;
        });
        if (gift) {
          return gift.accunulate * 100;
        }
        return 0;
      },
      // 幸运礼物暴击状态倒计时
      get multiEndTime() {
        let { multiLuckyGifts = [] } = getRoot(self);
        let gift = multiLuckyGifts.find((i) => {
          return i.gift_id === self.id;
        });
        if (gift) {
          return gift.endTime;
        }
        return null;
      },
      get multiTotalTime() {
        let { multiLuckyGifts = [] } = getRoot(self);
        return multiLuckyGifts[0]?.totalTime || 180;
      },
    };
  });

const GiftCategoryModel = types
  .model('GiftCategoryModel', {
    // 分类id
    id: types.identifier, // string
    // 分类名称
    name: types.string,
    order: types.number,
    level_down: types.optional(types.number, 0),
    level_up: types.optional(types.number, 0),
    gifts: types.optional(types.array(GiftModel), []),
  })
  .views((self) => {
    return {
      get isPrivilege() {
        return self.name.indexOf('特权') > -1;
      },
    };
  });

const multiLuckyGiftModal = types.model('multiLuckyGiftModal', {
  gift_id: types.number,
  accunulate: types.number, //暴击进度
  endTime: types.maybeNull(types.number),
  totalTime: types.number, // 持续时间
});

const bagCategory = {
  id: 'bag',
  name: '背包',
  order: 9999,
  level_down: 0,
  level_up: 1000000000,
  gifts: [],
};

const initState = {
  categories: [],
  gifts: [],
  bagCategory,
  multiLuckyGifts: [],
};

const omitLuckGifts = (items, isOmitLuckGifts) => {
  if (isOmitLuckGifts) {
    return items.filter((i) => `${i.id}` !== '22');
  }
  return items;
};

const GiftTabModel = types
  .model('GiftTabModel', {
    categories: types.array(GiftCategoryModel),
    isOmitLuckGifts: true, // 是否过滤幸运礼物
    isOmitLandlordGifts: true, // 是否过滤斗地主礼物
    gifts: types.array(GiftModel),
    bagCategory: GiftCategoryModel,
    currentCategory: types.safeReference(GiftCategoryModel),
    currentGiftId: 0,
    currentGiftIsBag: false,
    hoverGift: types.maybeNull(GiftModel),
    heightOffset: 0, // 高度 60的整数倍，一行的高度
    multiLuckyGifts: types.array(multiLuckyGiftModal),
    mode: 'pc', // 模式 pc | client
  })
  .views((self) => {
    return {
      get allCategories() {
        const allItems = self.categories.concat(self.bagCategory);
        return allItems.filter((item) => {
          if (self.isOmitLuckGifts && item.id === '22') {
            // 幸运武林p
            return false;
          }
          if (self.isOmitLandlordGifts && item.id === '7777') {
            // 斗地主礼物
            return false;
          }
          return true;
        });
        // return omitLuckGifts(allItems, self.isOmitLuckGifts).filter((item) => {
        //   // 个播的话 仅房间的当前主播展示
        //   return !item.isPrivilege;
        // });
      },
      get currentGift() {
        return self.gifts.find((item) => item.id === self.currentGiftId);
      },
    };
  })
  .actions((self) => {
    const update = (categories, gifts) => {
      self.categories = categories; // omitLuckGifts(categories, self.isOmitLuckGifts);

      if (!self.currentCategory) {
        self.currentCategory = self.allCategories[0].id;
      }
      self.gifts = gifts;
    };

    const updateMultiLuckyGifts = (obj) => {
      self.multiLuckyGifts = obj;
    };

    const updateMultiLuckyGiftItem = (data) => {
      let gift = self.multiLuckyGifts.find((i) => {
        return i.gift_id === data.gift_id;
      });
      gift.accunulate = data.accunulate;
      gift.endTime = data.endTime || null;
    };

    const selectCurrentCategory = (id) => {
      self.currentCategory = id;
    };

    const selectCurrentGift = (giftId, isBag) => {
      self.currentGiftId = giftId;
      self.currentGiftIsBag = isBag;
    };

    const selectHoverGift = (gift) => {
      self.hoverGift = gift ? gift.toJSON() : null;
    };

    // 幸运武林的
    const omitLuckCategory = (toggle) => {
      self.isOmitLuckGifts = toggle;
      selectCurrentGift(0, false);
    };
    const omitLandlordCategory = (toggle) => {
      self.isOmitLandlordGifts = toggle;
      selectCurrentGift(0, false);
    };

    const setHeightOffset = (height) => {
      self.heightOffset = height;
    };

    const setMode = (name) => {
      self.mode = name;
    };

    return {
      update,
      updateMultiLuckyGifts,
      updateMultiLuckyGiftItem,
      selectCurrentCategory,
      omitLuckCategory,
      omitLandlordCategory,
      selectCurrentGift,
      selectHoverGift,
      setHeightOffset,
      setMode,
    };
  });

// export default {
//   initState,
//   GiftModel,
//   GiftCategoryModel,
//   GiftTabModel
// };

let { store, Provider, useStore } = createStore(GiftTabModel, initState);

const getStore = () => {
  return store;
};

export {
  store,
  Provider,
  useStore,
  GiftModel,
  getStore,
  // GiftCategoryModel,
  // GiftTabModel
};
